import React, { useState } from "react";
import { useSelector } from "react-redux";
const Button = ({ title, onClick, active, isModal, targetValue }) => {
  const brand = useSelector((state) => state.brand);
  const [bgColor, setBgColor] = useState("white");
  const [txtColor, setTxtColor] = useState("black");
  const handleMouseOver = () => {
    if (brand && brand.hex) setBgColor(brand.hex);
    if (brand && brand.white) setTxtColor("white");
  };
  const handleMouseLeave = () => {
    setBgColor("white");
    setTxtColor("black");
  };
  return (
    <button
      className="btn"
      style={{
        backgroundColor:
          active !== null ? (active ? brand.hex : bgColor) : bgColor,
        color: active !== null ? (active ? "white" : txtColor) : txtColor,
        margin: 10,
      }}
      onClick={onClick}
      onMouseOver={handleMouseOver}
      onMouseLeave={handleMouseLeave}
      data-toggle={isModal ? "modal" : ""}
      data-target={targetValue}
    >
      {title}
    </button>
  );
};
export default Button;



// WEBPACK FOOTER //
// ./src/screens/Users/Button.js